var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',{attrs:{"id":"login-singpass-callback","name":"login-singpass-callback"},on:{"page:afterin":_vm.afterin}},[_c('f7-block')],1)}
var staticRenderFns = []

export { render, staticRenderFns }